import { useNode } from "@craftjs/core";

import type { VideoGridProps } from "../video-grid-component";
import { AdvancedSettings } from "./advanced-settings";
import { VideoOrderSettings } from "./video-order-settings";
import { VideoSettings } from "./video-settings";

export function VideoGridSettings() {
  const { props } = useNode((query) => {
    const filteredVideoList = query.props.videoList.filter((video) => {
      return typeof video !== "string";
    });
    return {
      props: {
        ...(query.props as VideoGridProps),
        videoList: filteredVideoList,
      },
    };
  });

  return (
    <>
      <div className="grid gap-4">
        <VideoSettings />
        {props.videoList.length !== 0 && <AdvancedSettings />}
        {props.videoList.length !== 0 && <VideoOrderSettings />}
      </div>
    </>
  );
}
